var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "mq9.fba9e0cb.png","uri@2x": __webpack_public_path__ + "mq9.a63d61f6.png","uri@3x": __webpack_public_path__ + "mq9.757fa49c.png",
    width: 132,
    height: 77
});